import React from "react";
import { Badge } from "@/components/ui/badge";
import { CheckCircle2, XCircle } from "lucide-react";

export function GraphStatusBadge({ configured }) {
  return configured ? (
    <Badge className="bg-emerald-100 text-emerald-700 hover:bg-emerald-100 border-emerald-200">
      <CheckCircle2 className="w-3 h-3 mr-1" strokeWidth={2} /> Configurado
    </Badge>
  ) : (
    <Badge className="bg-amber-100 text-amber-700 hover:bg-amber-100 border-amber-200">Pendiente</Badge>
  );
}

export function GraphTestResult({ result }) {
  if (!result) return null;
  const tone = result.ok ? "bg-emerald-50 border-emerald-200 text-emerald-700" : "bg-red-50 border-red-200 text-red-700";
  return (
    <div className={`mt-3 p-3 rounded-md border text-xs ${tone}`}>
      <div className="flex items-center gap-2">
        {result.ok ? (
          <>
            <CheckCircle2 className="w-4 h-4" strokeWidth={2} />
            Conexión OK · Organización: <strong>{result.organization}</strong>
          </>
        ) : (
          <>
            <XCircle className="w-4 h-4" strokeWidth={2} />
            {result.error}
          </>
        )}
      </div>
    </div>
  );
}

export function GraphPermissionsNote() {
  return (
    <div className="mt-4 p-3 rounded-md bg-slate-50 border border-slate-200 text-xs text-slate-600 leading-relaxed">
      <strong>Permisos Graph requeridos (Application):</strong> User.Read.All,
      Directory.Read.All, Group.Read.All. Recuerda otorgar consentimiento admin en
      el portal de Entra ID.
    </div>
  );
}
